const actions = {
  async getDashboardConfig({ commit, rootState: { $http } }, { domain }) {
    const { data } = await $http.get(`/config?domain=${domain}`);

    commit('setDashboardConfig', data.data.config);
  },
};

export default actions;
